<template>
    <div class="media-artwork-container text-center text-md-center">
        <a :href="item.link" class="media-detail-artwork color-white media-artwork-container-hover">

            <div class="img-media-detail-artwork-icon">
                <i :class="[item.fa_background]" class="fa-20x"></i>
            </div>

            <span class="media-detail-type-badge-container career-badge top-left">
                <span class="badge media-detail-type-badge no-drop-shadow">{{item.type}}</span>
            </span>

            <span class="media-detail-type-badge-container top-right">
                <span class="badge media-detail-type-badge no-drop-shadow">{{item.salary}}</span>
            </span>

            <span class="media-detail-type-badge-container bottom-left">
                <span class="badge media-detail-type-badge no-drop-shadow">{{item.location}}</span>
            </span>

            <span class="media-detail-type-badge-container bottom-right">
                <span class="badge media-detail-type-badge no-drop-shadow">Apply<i class="fas fa-angle-double-right ml-2"></i></span>
            </span>
            

            <span class="media-detail-title">{{item.title}}</span>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['item','index'],
        data () {
            return {
            }
        },
        methods: {
        },
        computed: {
            "artworkSrc": function(){
                var url = `https://cdn.sleepjar.com/sleepsounds/images/artwork/sound`;
                url += `/icon/white/svg/rain.svg`;
                return url;
            },
        }
    }
</script>
